import Swiper from "swiper/bundle";

(function ($) {
    $(document).ready(function () {

        const swiper = new Swiper(".other-products__slider", {
            slidesPerView: 4,
            loop: false,
            speed: 1000,
            pagination: {
                el: ".other-products .other-products__slider .swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: ".other-products .other-products__slider .swiper-button-next",
                prevEl: ".other-products .other-products__slider .swiper-button-prev",
            },
            breakpoints: {
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 20 
                },
                668: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                1: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
            }
        });
    });

})(jQuery);
